import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useMaintenance } from '@/contexts/useMaintenance';
import MaintenancePage from '@/components/MaintenancePage';

interface MaintenanceWrapperProps {
  children: ReactNode;
}

const MaintenanceWrapper: React.FC<MaintenanceWrapperProps> = ({ children }) => {
  const location = useLocation();
  const { isInMaintenance, canBypassMaintenance, loading } = useMaintenance();

  // Define public routes that should be accessible during maintenance
  const publicRoutes = ['/', '/about', '/contact', '/login', '/signup', '/forgot-password', '/reset-password'];
  const isPublicRoute = publicRoutes.includes(location.pathname);

  // Fail-open: render children while loading (don't block the entire app).
  // Only show the maintenance page after confirming maintenance is actually ON.
  if (!loading && isInMaintenance && !canBypassMaintenance && !isPublicRoute) {
    return <MaintenancePage />;
  }

  // Otherwise, render children normally (includes loading state)
  return <>{children}</>;
};

export default MaintenanceWrapper;
